<!-- 
  SkyPlus Custom Login Component - OAuth Version
  Location: alfresco-content-app/app/src/app/components/skyplus/login/skyplus-login.component.html
  
  This version uses a "Sign In" button that redirects to Keycloak,
  instead of a username/password form.
-->

<!-- ============================================================================ -->
<!-- SPLIT SCREEN MODE (Default) -->
<!-- ============================================================================ -->
<div class="sp-login" *ngIf="displayMode === 'split-screen'">
  
  <!-- Left Panel - Branding -->
  <div class="sp-login__brand-panel">
    <div class="sp-login__brand-content">
      <img [src]="brand.logoWhiteUrl" [alt]="brand.companyName" class="sp-login__brand-logo"
           onerror="this.style.display='none'">
      
      <h1 class="sp-login__brand-title">
        Welcome to<br>
        <span>{{ brand.companyName }}</span>
      </h1>
      
      <p class="sp-login__brand-tagline">{{ brand.tagline }}</p>
      
      <!-- Feature Highlights -->
      <div class="sp-login__features">
        <div class="sp-login__feature">
          <div class="sp-login__feature-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
            </svg>
          </div>
          <div class="sp-login__feature-text">
            <strong>Document Management</strong>
            <span>Secure storage and organization</span>
          </div>
        </div>
        
        <div class="sp-login__feature">
          <div class="sp-login__feature-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"/>
            </svg>
          </div>
          <div class="sp-login__feature-text">
            <strong>Workflow Automation</strong>
            <span>Streamline your processes</span>
          </div>
        </div>
        
        <div class="sp-login__feature">
          <div class="sp-login__feature-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/>
            </svg>
          </div>
          <div class="sp-login__feature-text">
            <strong>Enterprise Security</strong>
            <span>Your data, protected</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Background Pattern -->
    <div class="sp-login__brand-pattern"></div>
  </div>
  
  <!-- Right Panel - Login -->
  <div class="sp-login__form-panel">
    <div class="sp-login__form-container">
      
      <!-- Mobile Logo (shown only on mobile) -->
      <div class="sp-login__mobile-logo">
        <img [src]="brand.logoUrl" [alt]="brand.companyName">
      </div>
      
      <div class="sp-login__form-header">
        <h2>Sign In</h2>
        <p>Click the button below to sign in with your organization account</p>
      </div>
      
      <!-- Error Message -->
      <div class="sp-login__error" *ngIf="errorMessage">
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
        </svg>
        <span>{{ errorMessage }}</span>
      </div>
      
      <!-- SSO Login Button -->
      <div class="sp-login__sso-section">
        <button type="button" class="sp-submit-btn sp-sso-btn" (click)="onLoginClick()" [disabled]="isLoading">
          <span *ngIf="!isLoading" class="sp-sso-btn-content">
            <!-- Keycloak/SSO Icon -->
            <svg viewBox="0 0 24 24" fill="currentColor" class="sp-sso-icon">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
            </svg>
            Sign In with SSO
          </span>
          <span *ngIf="isLoading" class="sp-loading">
            <span class="sp-spinner"></span>
            Redirecting...
          </span>
        </button>
        
        <p class="sp-sso-hint">
          You will be redirected to your organization's login page
        </p>
      </div>
      
      <!-- Divider -->
      <div class="sp-login__divider">
        <span>Secure Authentication</span>
      </div>
      
      <!-- Security Info -->
      <div class="sp-login__security-info">
        <div class="sp-security-item">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
          </svg>
          <span>Encrypted Connection</span>
        </div>
        <div class="sp-security-item">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"/>
          </svg>
          <span>Enterprise Security</span>
        </div>
      </div>
      
      <!-- Footer -->
      <div class="sp-login__footer">
        <p>&copy; 2025 {{ brand.companyName }}. All rights reserved.</p>
      </div>
    </div>
  </div>
</div>


<!-- ============================================================================ -->
<!-- BACKGROUND IMAGE MODE (Alternative) -->
<!-- ============================================================================ -->
<div class="sp-login sp-login--bg-image" *ngIf="displayMode === 'background-image'" 
     [style.background-image]="'url(' + brand.backgroundUrl + ')'">
  
  <div class="sp-login__overlay"></div>
  
  <div class="sp-login__card">
    <!-- Logo -->
    <div class="sp-login__card-logo">
      <img [src]="brand.logoUrl" [alt]="brand.companyName" onerror="this.style.display='none'">
    </div>
    
    <!-- Header -->
    <div class="sp-login__card-header">
      <h2>Welcome Back</h2>
      <p>Sign in to continue to your workspace</p>
    </div>
    
    <!-- Error Message -->
    <div class="sp-login__error" *ngIf="errorMessage">
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
      </svg>
      <span>{{ errorMessage }}</span>
    </div>
    
    <!-- SSO Login Button -->
    <div class="sp-login__sso-section">
      <button type="button" class="sp-submit-btn sp-sso-btn" (click)="onLoginClick()" [disabled]="isLoading">
        <span *ngIf="!isLoading" class="sp-sso-btn-content">
          <svg viewBox="0 0 24 24" fill="currentColor" class="sp-sso-icon">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
          </svg>
          Sign In with SSO
        </span>
        <span *ngIf="isLoading" class="sp-loading">
          <span class="sp-spinner"></span>
          Redirecting...
        </span>
      </button>
    </div>
    
    <!-- Footer -->
    <div class="sp-login__card-footer">
      <p>Powered by <strong>{{ brand.companyName }}</strong></p>
      <p class="sp-tagline">{{ brand.tagline }}</p>
    </div>
  </div>
</div>